import React, { useEffect, useState } from 'react';
import './MobileMenu.scss';
import MenuHeader from './MenuHeader';
import MenuFooter from './MenuFooter';
import MenuList from './MenuList';

export default function MobileMenu({ siginInCta, contactUsCta, menuData, footerData }) {
    // console.log('MobileMenu menuData', menuData);
    const [stack, setStack] = useState([menuData.menu_items || []]);
    const [divisions, setDivisions] = useState([]);
    const [open, setOpen] = useState(false);
    const [hasNestedBack, setHasNestedBack] = useState(false);
    const [parentViewAll, setParentViewAll] = useState(null);
    const [resourcesFeatured, setResourcesFeatured] = useState([]);

    // Track both current title and subtitle
    const [currentTitle, setCurrentTitle] = useState('');
    const [currentSubtitle, setCurrentSubtitle] = useState('');

    const currentMenu = stack[stack.length - 1] || [];

    // Reset to root menu
    const handleBack = () => {
        setStack([menuData.menu_items || []]);
        setDivisions(false);
        setHasNestedBack(false);
        setCurrentTitle('Menu');
        setCurrentSubtitle('');
    };

    // Go back one level
    const handleNestedBack = () => {
        setStack((prev) => prev.slice(0, -1));
        setDivisions(false);
        setHasNestedBack(false);
        setCurrentSubtitle('');
    };

    // Reset when menuData changes
    useEffect(() => {
        setStack([menuData.menu_items || []]);
    }, [menuData]);

    // Navigate into child menu with title + subtitle
    const handleNext = (children, title = '', subtitle = '', viewAll = null) => {
        let resolvedViewAll = viewAll;
        let resolvedFeatured = null;
        if (!resolvedViewAll && Array.isArray(currentMenu)) {
            const parentItem = currentMenu.find(
                (item) =>
                    item.title?.toLowerCase() === title?.toLowerCase() ||
                    item.id?.toLowerCase() === title?.replace(/\s/g, '_').toLowerCase()
            );
            // Try to get view_all from content
            resolvedViewAll = parentItem?.content?.view_all || parentItem?.view_all || null;
            // 🎯 Capture featured_content here if present
            resolvedFeatured = parentItem?.content?.featured_content || null;
        }

        if (Array.isArray(children) && children.length) {
            setStack((prev) => [...prev, children]);
            setCurrentTitle(title);
            setCurrentSubtitle(subtitle);
            setParentViewAll(resolvedViewAll); // <-- set the view_all data
            setResourcesFeatured(resolvedFeatured);
        }
    };

    // Debug logs
    useEffect(() => {
        // console.log('useEffect hasNestedBack', hasNestedBack);
        // console.log('useEffect currentMenu', currentMenu);
        // console.log('useEffect stack', stack);
        // console.log('useEffect currentTitle', currentTitle);
        // console.log('useEffect currentSubtitle', currentSubtitle);
    }, [hasNestedBack, currentMenu, stack, currentTitle, currentSubtitle]);

    return (
        <>
            {!open && (
                <button className="menu-toggle" onClick={() => setOpen(true)}>
                    ☰
                </button>
            )}
            <div
                className={`menu-overlay ${open ? 'show' : ''}`}
                onClick={() => setOpen(false)}>
                <div className="menu-panel" onClick={(e) => e.stopPropagation()}>
                    <MenuHeader
                        logo={menuData?.logo}
                        hasBack={stack.length > 1}
                        onBack={handleBack}
                        onNestedBack={handleNestedBack}
                        hasNestedBack={hasNestedBack}
                        onClose={() => setOpen(false)}
                        title={currentTitle}
                        subtitle={currentSubtitle} // <-- pass subtitle
                    />

                    {currentMenu && (
                        <MenuList
                            items={currentMenu}
                            setHasNestedBack={setHasNestedBack}
                            onNext={(children, title, subtitle, viewAll) =>
                                handleNext(children, title, subtitle, viewAll)
                            }
                            contactUsCta={contactUsCta}
                            siginInCta={siginInCta}
                            hasNestedBack={hasNestedBack}
                            hasBack={stack.length > 1}
                            onClose={() => setOpen(false)}
                            setDivisions={setDivisions}
                            divisions={divisions}
                            currentTitle={currentTitle}
                            currentSubtitle={currentSubtitle}
                            footerData={footerData}
                            onNestedBack={handleNestedBack}
                            parentViewAll={parentViewAll} // <-- pass the prop
                            resourcesFeatured={resourcesFeatured}
                        />
                    )}

                    {/* <MenuFooter footerData={footerData||{}} /> */}
                </div>
            </div>
        </>
    );
}
